import {
    icons,
    SET_SEARCH,
    UPDATE_LIST,
    UPDATE_STATUS,
    RESET_LIST,
    iconConfig
} from "../types";
import db from "js/db";

export const fetchConfig = () => {
    return {
        types: [
            iconConfig.fetchStart,
            iconConfig.fetchSuccess,
            iconConfig.fetchError
        ],
        promise: () =>
            db("config")
                .once("value")
                .then(snapshot => snapshot.val())
    };
};

export const fetchIcons = manifest => dispatch => {
    return fetch(manifest)
        .then(response => {
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();
        })
        .then(result => {
            dispatch({ type: icons.fetchSuccess, result });
        })
        .catch(err => {
            dispatch({ type: icons.fetchError, result: err });
        });
};

export const searchIcon = term => {
    return { type: SET_SEARCH, result: term };
};

export const updateList = (count = 100) => (dispatch, store) => {
    let { list, data, status } = store().icons.icons;
    let listedCount = list.length;
    dispatch({ type: UPDATE_STATUS, result: "loading" });

    if (status !== "complete") {
        let updates = data.slice(listedCount, listedCount + count);
        dispatch({ type: UPDATE_LIST, result: updates });

        if (listedCount + count >= data.length) {
            dispatch({ type: UPDATE_STATUS, result: "complete" });
        } else {
            dispatch({ type: UPDATE_STATUS, result: "success" });
        }
    }
};
